import React from 'react';
import { Tooltip } from '@mui/material';
import { ContainerV1, ContainerV1Properties } from '@adobe/aem-core-components-react-spa';
import { useRole } from '../../../../lib/context/SessionContext';
import { useAemEditor } from '../../../../lib/context/AemEditorContext';
import Badge from '../../../common/Badge/Badge';
import { classes } from '../../../../lib/utils/cssUtils';
import Layout from '../../../common/Layout/Layout';
import styles from './ProtectedContainer.module.scss';
import AuthoringMessage from '../../../dev/AuthoringMessage/AuthoringMessage';

export type ProtectedContainerProps = ContainerV1Properties & { personas: string[] };

const ProtectedContainer = (props: ProtectedContainerProps) => {
  const role = useRole();
  const { authoringEditMode } = useAemEditor();

  if (!role) {
    return null;
  }

  const { personas = [], isInEditor } = props;
  const limitedAccess = !!personas.length;
  const hasAccess = !limitedAccess || personas.includes(role);

  if (isInEditor && limitedAccess) {
    return (
      <div
        className={classes({
          [styles.borderedContainer]: authoringEditMode === 'edit',
          [styles.noAccessBorder]: !hasAccess,
        })}
      >
        <Layout className={styles.layoutContainer}>
          <Tooltip
            className={styles.info}
            title={<span className={styles.infoContent}>This component access is limited only to these roles.</span>}
            placement="top-end"
          >
            <div className={styles.rolesContainer}>
              {personas.map(persona => (
                <Badge key={persona} variant="regular" className={styles.badge}>
                  {persona}
                </Badge>
              ))}
            </div>
          </Tooltip>
        </Layout>
        <div className={classes({ [styles.hide]: authoringEditMode === 'preview' && !hasAccess })}>
          <ContainerV1 {...props} />
        </div>
        {authoringEditMode === 'preview' && !hasAccess && (
          <AuthoringMessage> Current role ({role}) will not be able to see this component.</AuthoringMessage>
        )}
      </div>
    );
  }

  return hasAccess ? <ContainerV1 {...props} /> : null;
};

export default ProtectedContainer;
